import { Injectable } from "@angular/core";
import { Observable, map } from "rxjs";
import {
  StaffPayrollResponsibleRequest,
  StaffPayrollResponsibleResponse,
  StaffPayrollResponsiblesService,
} from "lib-klab-sdks";
import { PayrollResponsiblesPort } from "../../../app/ports/organization/payroll-responsibles.port";
import {
  PayrollResponsible,
  PayrollResponsibleRequest,
} from "../../../domain/models/organization/payroll-responsible.model";

@Injectable({ providedIn: "root" })
export class PayrollResponsiblesPortAdapter implements PayrollResponsiblesPort {
  constructor(private readonly api: StaffPayrollResponsiblesService) {}

  list(filters?: {
    companyId?: number;
    status?: string;
  }): Observable<PayrollResponsible[]> {
    return this.api
      .list(filters)
      .pipe(map((items) => items.map(mapResponsible)));
  }

  getById(id: number): Observable<PayrollResponsible> {
    return this.api.getById(id).pipe(map(mapResponsible));
  }

  create(request: PayrollResponsibleRequest): Observable<PayrollResponsible> {
    return this.api.create(mapRequest(request)).pipe(map(mapResponsible));
  }

  update(
    id: number,
    request: PayrollResponsibleRequest,
  ): Observable<PayrollResponsible> {
    return this.api.update(id, mapRequest(request)).pipe(map(mapResponsible));
  }

  setStatus(id: number, active: boolean): Observable<PayrollResponsible> {
    return this.api.setStatus(id, active).pipe(map(mapResponsible));
  }

  delete(id: number): Observable<void> {
    return this.api.delete(id);
  }
}

function mapResponsible(
  item: StaffPayrollResponsibleResponse,
): PayrollResponsible {
  return {
    id: item.payrollResponsibleId,
    companyId: item.companyId,
    firstName: item.firstName,
    lastName: item.lastName,
    documentType: item.documentType,
    documentNumber: item.documentNumber,
    phoneCountryCode: item.phoneCountryCode,
    phone: item.phone,
    nationality: item.nationality,
    departmentId: item.departmentId,
    email: item.email,
    status: item.status,
  };
}

function mapRequest(
  request: PayrollResponsibleRequest,
): StaffPayrollResponsibleRequest {
  return { ...request };
}
